// extracted by mini-css-extract-plugin
export default {"container":"PreviewPage_container__Cs3Q-","box":"PreviewPage_box__UWI00"};